import { DatePipe } from '@angular/common';
import { Route } from '@angular/compiler/src/core';
import { Component, EventEmitter, HostListener, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertsCenterService } from 'src/app/core/services/alerts-center.service';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { StoricoSegnalazioneDataSource } from 'src/app/services/storico-segnalazione.datasource';
import { StoricoSegnalazioneService } from 'src/app/services/storico-segnalazione.service';
import { Toolbar, ToolbarEvent } from 'src/app/shared/components/toolbar/toolbar';

@Component({
  selector: 'app-storico-segnalazione',
  templateUrl: './storico-segnalazione.component.html',
  styleUrls: ['./storico-segnalazione.component.css']
})
export class StoricoSegnalazioneComponent implements OnInit {

  dataSource: StoricoSegnalazioneDataSource;
  displayedColumns: string[] = ['storicizzazione', 'stato', 'dataUltimaModifica', 'utenteUltimaModifica', 'actions'];
  codiceSegnalazione: number;
  fromDettaglioPage: boolean = false;
  fromModificaPage: boolean = false;

  @Output()
  public onToolbarEvent: EventEmitter<ToolbarEvent> = new EventEmitter();
  public toolbar: Toolbar;
  openToggle: number;
  //aggiunto x evitare errore
  acl: any;


  constructor(private datePipe:DatePipe, private storicoSegnalazioneSvc: StoricoSegnalazioneService, private route: ActivatedRoute, private router: Router,private alertsCenterService: AlertsCenterService, private authenticationService: AuthenticationService) {
    this.codiceSegnalazione = this.route.snapshot.params.idSegnalazione;
    if(this.router.url.includes("dettaglio-segnalazione")){
      this.fromDettaglioPage = true;
      this.fromModificaPage = false;
    }else if(this.router.url.includes("compilazione-segnalazione")){
      this.fromDettaglioPage = false;
      this.fromModificaPage = true;
    }
    this.generateToolBar();
  }

  ngOnInit(): void {
    this.dataSource = new StoricoSegnalazioneDataSource(this.storicoSegnalazioneSvc);
    this.dataSource.errors$.subscribe(res => {
      if(res) this.alertsCenterService.showAlert({
        message: `Errore lettura dati`,
        type: 'danger',
        autoClosable: false
      });
    })
    //aggiunto x evitare errore
    this.acl = sessionStorage.getItem('acl');
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.dataSource.loadStoricoSegnalazione('',this.codiceSegnalazione,'dataUltimaModifica,DESC',0);
    });
  }

  previousPage() {
    this.router.navigate([this.router.url.replace('/storico-segnalazione', '')]);
  }

  private generateToolBar() {

    this.toolbar = {
      toolbarCss: 'toolbar-vertical',
      actions: [
        {
          btnTitle: 'Dettaglio',
          btnIconClass: 'article',
          btnActionEvent: 'detail',
          btnCssClass: 'btn btn-secondary'
        }
      ]
    }
  }

  public handleToolbarEvent(event: ToolbarEvent): void {
    if (event.event === 'detail') {
      if(this.router.url.includes("dettaglio-segnalazione")){
        this.router.navigate(["lista-segnalazioni/" + this.route.snapshot.params.id + "/dettaglio-segnalazione/dettaglio-segnalazione-storico/" + event.data.idDatiRaccolti], {state: {storicizzazione: event.data.dataStoricizzazione}});
      } else if (this.router.url.includes("compilazione-segnalazione")) {
        this.router.navigate(["lista-segnalazioni/" + this.route.snapshot.params.id + "/compilazione-segnalazione/dettaglio-segnalazione-storico/" + event.data.idDatiRaccolti], {state: {storicizzazione: event.data.dataStoricizzazione}});
      }
    }
  }
 //rimane in ascolto: se il click non è fatto sull'icona chiude il menù
 @HostListener('document:click', ['$event'])
 documentClick(event) {
     if(event.srcElement.innerText !== 'more_horiz') this.openToggle = 0;
 }
}
